import { lazy } from "react";
import { gradients } from "@/lib/constants";
import { ElementDetails } from "@/lib/types";
import { CountdownProps } from "./types";

export const details = {
  name: "Countdown",
  description: "Count down the days to an exam, deadline, or event",
  tags: ["Productivity", "School"],
  category: "Widget",
  setup: lazy(() =>
    import("./Settings").then(m => ({ default: m.CountdownSettings })),
  ),
  grid: {
    small: [2, 2],
    medium: [3, 2],
  },
  defaultProps: {
    color: gradients[3],
    title: "",
    targetDate: "",
  },
} as ElementDetails<CountdownProps>;
